<template>
  <div v-if="data">
    <div class="env" v-if="env === 'dev' || env === 'qa'">Miljö: {{ env }}</div>
    <nav class="navbar fixed-top bg-white">
      <a :href="setHref()" :class="disableHref ? 'disabled-href' : ''">
        <img
          src="@/assets/img/logo.svg?data"
          alt="FHabian.nu logotyp"
          class="img-fluid img-logo"
        />
      </a>
      <div v-if="!region">
        <div class="row row-margin mr-2">
            <div class="col-lg-8">
            <img
              :src="require( `../assets/img/regioner/SE2321000016/header.svg`)"
              alt="Header för Region Stockholm"
              class="img-margin header sthlmlogo"
              v-if="!isDashboardOrFamilytree"
            />
            </div>
            <div class="col-lg-4">
            <img
              :src="require( `../assets/img/regioner/SE162321000255/header.svg`)"
              alt="Header för Region Skåne"
              class="img-margin header skanelogo"
              v-if="!isDashboardOrFamilytree"
            />
            </div>
        </div>
      </div>
      <!-- <div v-if="region && !isDashboardOrFamilytree">
        <img
          :src="require( `../assets/img/regioner/` + region + `/header.svg`)"
          alt="Header för specifik region"
          class="img-fluid header" style="margin-right: 135px"
        />
      </div> -->
      <router-link v-if="isRoot" class="top-right-register" to="/register">Registrering</router-link>
      <router-link v-if="isRoot" class="top-right-login" to="/login">Logga in</router-link>
      <img
        src="@/assets/img/hamburger.svg?data"
        alt="Ikon för hamburgarmeny"
        class="navbar-toggler img-fluid"
        data-toggle="collapse"
        data-target="#collapsibleNavbar"
      />
      <!-- Vanlig horizontell menyrad -->
      <ul class="nav-horizontal">
        <li class="nav-item nav-horizontal-li">
          <a :href="setHref()" :class="disableHref ? 'disabled-href' : ''"
          class="nav-link">Till start</a>
        </li>
        <li class="nav-item nav-horizontal-li">
          <div class="divider"></div>
          <router-link
            class="nav-link"
            :to="{ name: 'faq', params: { page: pages.whatisfh } }">
            {{ data.faq.topHeader1 }}
          </router-link>
        </li>
        <li class="nav-item nav-horizontal-li">
          <div class="divider"></div>
          <router-link
            class="nav-link"
            :to="{ name: 'faq', params: { page: pages.aboutapp } }">
            {{ data.faq.topHeader3 }}
          </router-link>
        </li>
        <li class="nav-item nav-horizontal-li">
          <div class="divider"></div>
          <router-link
            class="nav-link"
            :to="{ name: 'faq', params: { page: pages.helpresearch } }">
            {{ data.faq.topHeader4 }}
          </router-link>
        </li>
        <li class="nav-item nav-horizontal-li">
          <div class="divider"></div>
          <router-link
            class="nav-link"
            :to="{ name: 'faq', params: { page: pages.contact } }">
            {{ data.faq.topHeader5 }}
          </router-link>
        </li>
      </ul>
      <div class="collapse navbar-collapse" id="collapsibleNavbar">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a :href="setHref()" :class="disableHref ? 'disabled-href' : ''"
            class="nav-link text-primary-fh">Till start</a>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link text-primary-fh"
              data-toggle="collapse"
              data-target="#collapsibleNavbar"
              :to="{ name: 'faq', params: { page: pages.whatisfh } }">
              {{ data.faq.topHeader1 }}
            </router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link
              class="nav-link text-primary-fh"
              data-toggle="collapse"
              data-target="#collapsibleNavbar"
              :to="{ name: 'faq', params: { page: pages.treatfh } }"
              v-html="data.faq.topHeader2">
            </router-link>
          </li> -->
          <li class="nav-item">
            <router-link
              class="nav-link text-primary-fh"
              data-toggle="collapse"
              data-target="#collapsibleNavbar"
              :to="{ name: 'faq', params: { page: pages.aboutapp } }">
              {{ data.faq.topHeader3 }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link text-primary-fh"
              data-toggle="collapse"
              data-target="#collapsibleNavbar"
              :to="{ name: 'faq', params: { page: pages.helpresearch } }">
              {{ data.faq.topHeader4 }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link text-primary-fh"
              data-toggle="collapse"
              data-target="#collapsibleNavbar"
              :to="{ name: 'faq', params: { page: pages.contact } }">
              {{ data.faq.topHeader5 }}
            </router-link>
          </li>
          <div class="dropdown-divider" v-if="notRootOrLogin() && doesTokenExist()"></div>
          <li class="nav-item" v-if="notRootOrLogin() && doesTokenExist()">
            <span
              class="nav-link text-primary-fh cursor-pointer"
              data-toggle="collapse"
              data-target="#collapsibleNavbar"
              @click="logOut()">
              <strong>Logga ut</strong>
            </span>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import $ from 'jquery'

export default {
  name: 'top',
  data () {
    return {
      data: null,
      disableHref: false,
      pages: {
        whatisfh: 'whatisfh',
        treatfh: 'treatfh',
        aboutapp: 'aboutapp',
        helpresearch: 'helpresearch',
        contact: 'contact'
      },
      env: process.env.NODE_ENV,
      region: 'SE2321000016'
    }
  },
  computed: {
    isDashboardOrFamilytree () {
      return this.$route.name === 'dashboard' ||
      this.$route.name === 'dashboardnf' ||
      this.$route.name === 'familytree'
    },
    isRoot () {
      return this.$route.path === '/'
    }
  },
  methods: {
    setHref () {
      const idxPat = (sessionStorage.getItem('isIndexPatient') === 'true')
      const hasVisitedDashboard = (sessionStorage.getItem('hasVisitedDashboard') === 'true')
      const hasVisitedDashboardNoReferral = (sessionStorage.getItem('hasVisitedDashboardNoReferral') === 'true')
      const hasVisitedDashboardCardio = (sessionStorage.getItem('hasVisitedDashboardCardio') === 'true')
      if (this.isDashboardOrFamilytree) {
        this.disableHref = true
      } else {
        if (idxPat) {
          return '/familytree'
        } else {
          if (hasVisitedDashboardNoReferral) {
            return '/dashboardnf'
          } else if (hasVisitedDashboardCardio) {
            return '/dashboardcardio'
          } else if (hasVisitedDashboard) {
            return '/dashboard'
          } else {
            return '/'
          }
        }
      }
    },
    logOut () {
      sessionStorage.clear()
      localStorage.removeItem('registerRelative')
      localStorage.removeItem('selectedRelatives')
      localStorage.removeItem('remittance')
      localStorage.removeItem('uri')
      localStorage.removeItem('age')
      localStorage.removeItem('reg')
      document.location.href = '/'
    },
    notRootOrLogin () {
      return location.pathname !== '/' && location.pathname !== '/login'
    },
    doesTokenExist () {
      if (sessionStorage.hasOwnProperty('jwt')) {
        return true
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          faq {
            topHeader1
            topHeader2
            topHeader3
            topHeader4
            topHeader5
          }
        }
      `
    })
    $(document).on('click', function () {
      $('#collapsibleNavbar').collapse('hide')
    })
    this.$root.$on('setRegion', (r) => {
      this.region = r
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* nav {
  filter: drop-shadow(0px 4px 14px rgba(224, 208, 192, 0.73));
} */
#collapsibleNavbar {
  z-index: 9999;
}
.env {
  z-index: 9999;
  background: #399bc8;
  position: fixed;
  top: 12%;
  letter-spacing: 1px;
  padding: 1%;
  font-size: 12px;
  color: #f0f0f0;
}
.navbar {
  height: 20vh;
}
.navbar-nav {
  margin-top: 5vh;
  width: 20vw;
  background: white;
  border: 2px solid #399bc8;
  border-radius: 15px;
}
.top-right-login {
  top: 16px;
  right: 86px;
  position: absolute;
}
.top-right-register {
  top: 16px;
  right: 156px;
  position: absolute;
  padding-right: 8px;
  border-right: 1px solid gray;
}
.divider {
  width: 2px;
  height: 20px;
  position: absolute;
  top: 25%;
  border-right: 2px solid #fff;
}
.nav-horizontal {
  margin-top: 18vh;
  position: absolute;
  background: #399bc8;
  width: 110vw;
  left: -5vw;
}
.nav-horizontal-li {
  margin: 0 0;
}
.nav-horizontal a {
  line-height: 20px;
  color: #fff !important;
  padding-top: 10px;
}
.nav-item {
  text-align: right;
}
.navbar-toggler {
  top: 8px;
  right: 8px;
  position: absolute;
  cursor: pointer;
  border: 0;
}
.navbar-header {
  margin-top: 1vh;
}
.navbar-span {
  margin-left: .5em;
}
.img-logo {
  width: 22vw;
  position: absolute;
  top: 6vh;
  left: 37vw;
}
.nav-link {
  font-size: 20px;
  float: right;
  margin-left: 10px;
}
.cursor-pointer {
  cursor: pointer;
}
.disabled-href {
  opacity: 0.3;
  pointer-events: none;
}
.img-margin {
  margin-left: 25px;
  margin-right: -10%;
}
.row-margin {
  margin-left: -200px;
}
/* Breakpoint for ugliness */
@media only screen and (max-width: 955px) {
  .nav-horizontal {
    display: none;
  }
  .nav-item a {
    font-size: .8em;
  }
  .img-logo {
    width: 35vw;
    position: absolute;
    top: 55%;
    left: 30vw;
  }
}
/* Portrait */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .navbar {
    border-bottom: 2px solid #069ccc;
  }
  .navbar-nav {
    width: 50vw;
    margin-top: 6vh;
  }
  .nav-link {
    font-size: 80%;
  }
  .nav-horizontal {
    display: none;
  }
  .fh-span {
    display: none;
  }
  .header {
    display: none;
  }
  .navbar-header {
    display: none;
  }
  .img-logo {
    width: 55vw !important;
    position: absolute;
    top: 13vh;
    left: 20vw;
  }
  .top-right-login {
    top: 0;
    right: 0;
    position: absolute;
    margin-right: 22vw;
    margin-top: 2vh;
  }
  .top-right-register {
    top: 0;
    right: 19vw;
    position: absolute;
    margin-right: 20vw;
    margin-top: 2vh;
  }
  .env {
    top: 2.22vh;
    padding: 1%;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue